import { convertStringToBuffer } from '../commands-utils/convertStringToBuffer'

export function bgrewriteaof() {
  return 'Background append only file rewriting started'
}

export function bgrewriteaofBuffer() {
  const val = bgrewriteaof.apply(this, [])
  return convertStringToBuffer(val)
}
